import { render, staticRenderFns } from "./TemplateItem.vue?vue&type=template&id=79e8bc5c&"
import script from "./TemplateItem.vue?vue&type=script&lang=ts&"
export * from "./TemplateItem.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QColor from 'quasar/src/components/color/QColor.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QColor});
